module.exports = __webpack_public_path__ + "img/logoElliPro.ef863134.png";